<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>公告</el-breadcrumb-item>
      <el-breadcrumb-item>公告详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="flex-row-between">
        <h3>
          {{ notice.title }}
          <el-tag
            size="small"
            class="ml-5"
            style="position: relative; top: -4px"
            v-if="notice.id"
            :type="NoticeStatusMap[notice.status].type"
            >{{
              notice.status == 3 && notice.flow_id
                ? '审批未通过'
                : NoticeStatusMap[notice.status].name
            }}</el-tag
          >
        </h3>
        <div style="ml-10">
          <el-button
            class="ml-10"
            type="primary"
            plain
            size="mini"
            v-if="notice.status != 1"
            v-permission="Auth.noticeEdit"
            @click="handleEdit"
            >编辑</el-button
          >
          <el-button
            class="ml-10"
            type="primary"
            plain
            size="mini"
            v-if="notice.user_id == userInfo.id"
            v-permission="Auth.noticeStatus"
            @click="showStatusDialog"
            >{{
              notice.status == 3
                ? auth.isPlatformUser()
                  ? '选择对象'
                  : '申请发布'
                : '撤回'
            }}</el-button
          >
          <el-button
            class="ml-10"
            type="primary"
            plain
            size="mini"
            v-permission="Auth.noticeApprove"
            v-if="
              notice.status == 2 &&
              userInfo.id == notice.approvers[notice.approve_index]
            "
            @click="handleApprove"
            >审批</el-button
          >
        </div>
      </div>

      <div class="mt-20 mb-20" v-if="notice.flow_id">
        <el-steps
          simple
          :space="180"
          :active="flowInfo.approve_index"
          finish-status="success"
          :process-status="notice.approve_status == 3 ? 'error' : 'process'"
        >
          <el-step
            :title="approver.name"
            :key="approver.name"
            v-for="approver in flowInfo.approvers"
          ></el-step>
        </el-steps>
      </div>

      <div class="flex-row-between font-12 mt-10">
        <span>发布者：{{ notice.user.name }}</span>
        <span>
          {{ formatTime(notice.created_at) }}
        </span>
      </div>
      <div
        style="font-size: 12px"
        v-if="notice.status != 3 && notice.dealer_id == 0"
      >
        通知对象：<span class="pointer text-primary" @click="showNotifierDetail"
          >{{
            (notice.publish_user_ids ? notice.publish_user_ids.length : 0) +
            (notice.publish_dealer_ids ? notice.publish_dealer_ids.length : 0)
          }}
          个</span
        >
      </div>
      <div style="margin-bottom: 20px" v-if="publish_dealers.length > 0">
        <el-tag
          style="margin-top: 5px; margin-right: 10px"
          size="mini"
          v-for="item in publish_dealers"
          :key="item.name"
        >
          {{ item.name }}
        </el-tag>
      </div>
      <p style="font-size: 12px; margin-bottom: 5px">
        分类：{{ notice.notice_category.whole_name || '无' }}
      </p>
      <p style="font-size: 12px; margin-bottom: 5px">
        摘要：{{ notice.summary || '无' }}
      </p>
      <div
        class="ql-editor pl-0"
        v-if="notice.content"
        v-html="notice.content"
      ></div>
      <div
        class="mt-10 file-list"
        v-if="notice.files && notice.files.length > 0"
      >
        <h4>附件</h4>
        <div class="flex-row" v-for="file in notice.files">
          <a :href="host + file.url" target="_blank">{{ file.name }}</a>
          <span class="pointer" v-show="!isMobile()" @click="download(file)"
            >下载</span
          >
        </div>
      </div>
    </div>

    <notice-former
      :model="model"
      :show.sync="visible"
      @updated="updatedCallback"
    ></notice-former>

    <notifier-detail
      :model="notice"
      :show.sync="notifierVisible"
    ></notifier-detail>
  </div>
</template>

<script>
import {
  noticeDetail,
  updateNoticeStatus,
  noticeApprove,
} from '@/service/getData'
import NoticeFormer from './former'
import NotifierDetail from './notifier_detail'
import { clone } from '@/util'
import { NoticeCategoryMap, NoticeStatusMap } from '../../../config/global'
import auth from '../../../util/auth'
import { formatTime, isMobile } from '../../../util'
import { dealerList } from '../../../service/getData'
import { host } from '../../../config/env'
import download from 'downloadjs'
import store from '@/store/store'

export default {
  components: {
    NoticeFormer,
    NotifierDetail,
  },
  data() {
    return {
      auth,
      userInfo: store.getters.userInfo,
      host,
      isMobile,
      formatTime,
      NoticeCategoryMap,
      NoticeStatusMap,
      id: this.$route.params.id,
      notice: { user: {}, notice_category: {} },
      category: 1,
      model: {},
      publish_dealers: [],
      visible: false,
      publishModel: {
        id: parseInt(this.$route.params.id),
        category: 1,
        publish_dealer_ids: [],
      },
      statusDialogvisible: false,
      notifierVisible: false,
    }
  },
  created() {
    this.getNotice()
  },
  computed: {
    flowInfo() {
      let info = { approve_index: 0, approvers: [] }
      if (this.notice.flow_id > 0) {
        let approve_index = this.notice.approve_index

        info.approve_index =
          this.notice.status == 1 ? approve_index + 1 : approve_index

        this.notice.approver_names.map((item, index) => {
          let name = item.split('&')
          let approver = { name: name[0], description: name[1] || '' }
          if (index < approve_index) {
            approver.name += '（已通过）'
          } else if (index == approve_index) {
            if (this.notice.status == 3) {
              approver.name += '（已驳回）'
            } else if (this.notice.status == 1) {
              approver.name += '（已通过）'
            } else {
              approver.name += '（审核中）'
            }
          } else {
            approver.name += '（待审核）'
          }

          info.approvers.push(approver)
        })
      }
      return info
    },
  },
  methods: {
    async getNotice() {
      let res = await noticeDetail(this.id)
      if (res.code == 0) {
        this.notice = res.data

        if (this.notice.category == 4) {
          this.getDealers()
        }
      }
    },
    showNotifierDetail() {
      this.notifierVisible = true
    },
    handleEdit() {
      this.model = clone(this.notice)
      this.model.notice_category_id = this.model.notice_category_id
        ? this.model.notice_category_id
        : ''
      this.model.files = this.model.files || []
      this.visible = true
    },
    updatedCallback(data) {
      this.notice = data
    },
    async getDealers() {
      let res = await dealerList({
        status: -1,
        dealer_ids: this.notice.publish_dealer_ids.join('&dealer_ids='),
      })
      if (res.code == 0) {
        this.publish_dealers = res.data.list
      }
    },
    showStatusDialog() {
      if (this.notice.status == 1 || this.notice.status == 2) {
        this.$confirm('确认撤回吗', '操作提示')
          .then(() => {
            updateNoticeStatus({
              id: this.notice.id,
            }).then((res) => {
              if (res.code == 0) {
                this.notice = res.data
                this.publish_dealers = []
                this.$message({
                  type: 'success',
                  message: '撤回成功',
                })
              }
            })
          })
          .catch((action) => {})
        return
      }
      if (auth.isPlatformUser()) {
        this.$router.push(`${this.notice.id}/user_select`)
      } else {
        this.$confirm('确认提交审核吗', '操作提示')
          .then(() => {
            updateNoticeStatus({
              id: this.notice.id,
            }).then((res) => {
              if (res.code == 0) {
                this.notice = res.data
                this.$message({
                  type: 'success',
                  message:
                    res.data.status == 1 ? '发布成功' : '提交成功，请等待审核',
                })

                if (this.notice.category == 4) {
                  this.getDealers()
                }
              }
            })
          })
          .catch((action) => {})
        return
      }
    },
    handleApprove() {
      let data = { id: this.notice.id, status: 1 }
      this.$confirm('请确认审批结果', '公告审批', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '驳回',
      })
        .then(async ({ value }) => {
          let res = await noticeApprove(data)
          if (res.code == 0) {
            this.notice = res.data
            this.$message({
              message: `操作成功`,
              type: 'success',
              center: true,
            })
          }
        })
        .catch(async (action) => {
          if (action == 'cancel') {
            data.status = 3
            let res = await noticeApprove(data)
            if (res.code == 0) {
              this.notice = res.data
              this.$message({
                message: `操作成功`,
                type: 'success',
                center: true,
              })
            }
          }
        })
    },
    download(file) {
      var x = new XMLHttpRequest()
      x.open('GET', this.host + file.url, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        download(e.target.response, file.name)
      }
      x.send()
    },
  },
}
</script>

<style scoped>
.file-list {
  padding-top: 20px;
  border-top: 1px solid #eee;
}
.file-list div {
  margin-top: 10px;
}

.file-list div span {
  margin-left: 12px;
  color: #999;
}
h4 {
  color: #888;
  font-size: 14px;
}
</style>